import cx from 'classnames'
import React from 'react'
import { Typography, TitleContainerProps } from '.'
import './styles.scss'

export interface SectionTitleProps extends Omit<TitleContainerProps, 'title' | 'style'> {
  title: React.ReactNode
  subtitle?: React.ReactNode
  styles?: { subtitle?: React.CSSProperties; title?: React.CSSProperties }
  extra?: React.ReactNode
  titleClassName?: string
  'data-testid'?: string
}

export function SectionTitle({
  title,
  subtitle,
  extra,
  className,
  titleClassName,
  children,
  level = 1,
  variant,
  'data-testid': dataTestId,
  styles,
  ...props
}: SectionTitleProps) {
  const { title: titleStyles, subtitle: subtitleStyles } = styles || {}
  return (
    <div className={cx('app-section-title', className)} style={titleStyles} data-testid={dataTestId}>
      <div className="u-flex-space-between">
        <Typography.Title level={level} variant={variant} className={titleClassName} {...props}>
          {title || children}
        </Typography.Title>
        {extra}
      </div>
      {subtitle ? (
        <Typography.Text type="secondary" className="app-section-subtitle" style={subtitleStyles}>
          {subtitle}
        </Typography.Text>
      ) : null}
    </div>
  )
}
